import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
  Accordion,
  Col,
  KeyValue,
  NoValue,
  Row,
  TextLink,
} from '@folio/stripes/components';
import { getJobViewUrl } from '../../../../../constants';

const TaskJob = ({
  job: {
    id,
    name,
    status,
    comment,
  },
}) => {
  const renderTaskLink = () => {
    return (
      <TextLink to={getJobViewUrl(id)}>
        {name}
      </TextLink>
    );
  };

  return (
    <Accordion
      id="jobDetails"
      label={<FormattedMessage id="ui-task-list.title.accordion.jobDetails" />}
    >
      <Row>
        <Col sm={3}>
          <KeyValue
            data-test-task-details-job-name
            label={<FormattedMessage id="ui-task-list.task.field.job.name" />}
            value={renderTaskLink()}
          />
        </Col>
        <Col sm={3}>
          <KeyValue
            data-test-task-details-job-status
            label={<FormattedMessage id="ui-task-list.task.field.job.status" />}
            value={<FormattedMessage id={`ui-task-list.job.statuses.${status}`} />}
          />
        </Col>
        <Col sm={3}>
          <KeyValue
            data-test-task-details-job-comment
            label={<FormattedMessage id="ui-task-list.task.field.job.comment" />}
            value={comment || <NoValue />}
          />
        </Col>
      </Row>
    </Accordion>
  );
};

TaskJob.propTypes = {
  job: PropTypes.shape({
    comment: PropTypes.string,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
  })
};

TaskJob.defaultProps = {
  job: PropTypes.shape({
    comment: '',
  })
};

export default TaskJob;
